import { CalendarMonth } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import React from "react";

interface DatePickerButtonProps {
  label: string;
  value: Date | null;
  placeholder: string;
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
  formatDate: (date: Date) => string;
  buttonRef?: React.RefObject<HTMLButtonElement>;
}

export const DatePickerButton: React.FC<DatePickerButtonProps> = ({
  label,
  value,
  placeholder,
  onClick,
  disabled = false,
  formatDate,
  buttonRef,
}) => {
  const dateButtonSx = {
    width: "100%",
    justifyContent: "space-between",
    bgcolor: "#F2F2F7",
    color: "#8E8E93",
    borderRadius: "16px",
    height: 48,
    border: "none",
    textTransform: "none",
    fontWeight: 500,
    fontStyle: "italic",
    fontSize: 14,
    lineHeight: "20px",
    letterSpacing: "0.02em",
    px: "18px",
    "&:hover": {
      bgcolor: "#E5E5EA",
    },
    "&.Mui-disabled": {
      bgcolor: "#F2F2F7",
      color: "#8E8E93",
      opacity: 0.6,
    },
  };

  return (
    <Stack spacing={1}>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 400,
          lineHeight: "16px",
          letterSpacing: "0.02em",
          color: "#48484A",
        }}
      >
        {label}
      </Typography>
      <Button
        disabled={disabled}
        endIcon={<CalendarMonth />}
        onClick={onClick}
        onMouseDown={(e) => e.stopPropagation()}
        ref={buttonRef}
        sx={dateButtonSx}
        variant="outlined"
      >
        {value ? formatDate(value) : placeholder}
      </Button>
    </Stack>
  );
};
